a.location.create = (function(){
	var my = {
		popup:function(o){
			if (a.s.ac.allow('content','location')) {
				var s = o || {};
				var cb = s.cb || function(){};
				var location = prompt("Enter name of location","");
				if (location != null) {
					my.save(location,cb);
				}
			}
			else {
				a.s.growl.create('Access denied','You have no access to this function',{});
			}
		},
		save:function(location,cb){
			var data = {};
			data.token = localStorage.getItem('token');
			data.accountname = localStorage.getItem('accountname');
			data.name = location;
			$.ajax({
				type:'POST',
				url:'/api/location/create/',
				data:data,
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						a.s.growl.create("Success","The location was added",{'duration':5000});
					}
					else if (result.errorlist) {
						result.errorlist.forEach(function(e){
							a.s.growl.create('Error',e.message,{
								duration:3500
							});
						});
					}
					else {
						a.s.growl.create("Error","Unable to add the location",{'duration':5000});
					}
					cb();
				}
			});
		}
	}
	return my;
}());